import { FC } from 'react';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import { Divider, Typography } from '@mui/material';
import { numberToCurrencyString } from 'further-ui/utils';
import { UnrealisedCashFXGainOrLossTypeLabels } from 'further-ui/labels';
import { Column } from 'further-ui/components/Layout';
import FormField from 'further-ui/components/FormField';

type Props = {
  recordId: string;
};

const CashHistoryDetailEmbedded: FC<Props> = ({ recordId }) => {
  const { vehicle } = useLayoutContext();

  const { data: record, isLoading } =
    api.unrealisedCashFxGainOrLoss.getById.useQuery(
      {
        vehicleId: vehicle?._id ?? '',
        recordId,
      },
      { enabled: !!vehicle?._id },
    );

  if (isLoading || !vehicle) {
    return null;
  }

  if (!record) {
    return <Typography>Record not found</Typography>;
  }

  return (
    <Column spacing="lg" fullWidth>
      <Divider />
      <FormField label="Date">
        <Typography variant="body2">
          {record.ledgerDate?.toLabel?.() ?? '-'}
        </Typography>
      </FormField>
      <FormField label="Bank Account">
        <Typography variant="body2">{record.bankAccountName ?? '-'}</Typography>
      </FormField>
      <FormField label="Type">
        <Typography variant="body2">
          {UnrealisedCashFXGainOrLossTypeLabels[record.gainOrLossType]}
        </Typography>
      </FormField>
      <FormField label="Amount (LCY)">
        <Typography variant="body2">
          {numberToCurrencyString(record.amountLcy, {
            currency: vehicle.baseCurrency,
            negativeInBrackets: true,
          })}
        </Typography>
      </FormField>
      <FormField label="Currency">
        <Typography variant="body2">{record.currencyCode}</Typography>
      </FormField>
      {record.reconciliationId && (
        <FormField label="Reconciliation">
          <Typography variant="body2">Yes</Typography>
        </FormField>
      )}
    </Column>
  );
};

export default CashHistoryDetailEmbedded;
